import { useState, useEffect } from "react";
import { useErs } from "src/context/ers/ers.provider";
import { usePromotionHub } from "src/hooks/usePromotionHub";
import { isPayloadPromotionsSource } from "src/utils/promotionsSource";

/**
 * Unified promotions hub loader — ERS or Payload based on REACT_APP_PROMOTIONS_SOURCE.
 *
 * @param {string} locale - `en` | `fr`
 * @returns {{
 *   promotions: import('src/utils/mapPromotion').PromotionCard[] | undefined,
 *   loading: boolean,
 *   error: string | null,
 * }}
 */
export function usePromotionsHubData(locale) {
  const usePayload = isPayloadPromotionsSource();
  const { data: ersData, fetchData, error: ersError } = useErs();
  const payload = usePromotionHub(locale);

  const [ersLoading, setErsLoading] = useState(!usePayload);

  useEffect(() => {
    if (usePayload) return;

    setErsLoading(true);

    fetchData(`promotions-${locale}`)
      .catch((err) => {
        console.error("Error fetching promotions from ERS:", err);
      })
      .finally(() => {
        setErsLoading(false);
      });
  }, [usePayload, fetchData, locale]);

  if (usePayload) {
    return {
      promotions: payload.data,
      loading: payload.loading,
      error: payload.error,
    };
  }

  return {
    promotions: ersData[`promotions-${locale}`],
    loading: ersLoading,
    error: ersError,
  };
}
